import { render, staticRenderFns } from "./DemoCards.vue?vue&type=template&id=cb8b02f2&"
import script from "./DemoCards.vue?vue&type=script&lang=js&"
export * from "./DemoCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports